// extracted by mini-css-extract-plugin
export default {"pageWithHeader":"pageWithHeader_nVMQP","pageWithHeaderContainer":"pageWithHeaderContainer_N_CkY"};